import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { namePattern } from './details-form-helpers';

/**
 * SECTION 4.4: CO-APPLICANT PERSONAL INFORMATION
 */
export function getCoApplicantPersonalFields(options: DetailsFormOptions): FormlyFieldConfig[] {
  return [
    // Personal Information
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Name',
          type: 'input',
          props: {
            label: 'First Name',
            required: true,
            maxLength: 20,
          },
          validators: {
            namePattern: {
              expression: (c: any) => !c.value || namePattern.test(c.value),
              message: 'Cannot contain digits or start/end with special characters',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Middle_Name',
          type: 'input',
          props: {
            label: 'Middle Name',
            maxLength: 20,
          },
          validators: {
            namePattern: {
              expression: (c: any) => !c.value || namePattern.test(c.value),
              message: 'Cannot contain digits or start/end with special characters',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Guarantor_Name',
          type: 'input',
          props: {
            label: 'Last Name',
            required: true,
            maxLength: 40,
          },
          validators: {
            namePattern: {
              expression: (c: any) => !c.value || namePattern.test(c.value),
              message: 'Cannot contain digits or start/end with special characters',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Gender',
          type: 'select',
          props: {
            label: 'Gender',
            options: [
              { value: 'Male', label: 'Male' },
              { value: 'Female', label: 'Female' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Date_of_Birth',
          type: 'datepicker',
          props: {
            label: 'Date of Birth',
            startView: 'multi-year',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Email',
          type: 'input',
          props: {
            label: 'Email',
            type: 'email',
          },
          validators: {
            email: {
              expression: (c: any) => !c.value || /^\S+@\S+\.\S+$/.test(c.value),
              message: 'Invalid email address',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Secondary_Cell_Number',
          type: 'phone',
          props: {
            label: 'Best Contact Number',
            required: true,
            prefix: '+1 ',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Secondary_Home_Number',
          type: 'phone',
          props: {
            label: 'Other Contact Number',
            prefix: '+1 ',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Secondary_S_I_N',
          type: 'sin',
          props: {
            label: 'SIN',
          },
          validators: {
            validation: ['sin'],
          },
        },
      ],
    },

    // Address Section Header
    {
      type: 'section-header',
      props: {
        label: 'Address',
      },
    },

    // Address
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Property_Address',
          type: 'google-address',
          props: {
            label: 'Address line 1',
            onAddressSelect: (result: any) => options.onAddressSelect(result, 'CO'),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Address_Line_2_Unit_number',
          type: 'input',
          props: {
            label: 'Address Line 2 (Unit number)',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_City',
          type: 'input',
          props: {
            label: 'City',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Province',
          type: 'input',
          props: {
            label: 'Province',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Postal_Code',
          type: 'postal-code',
          props: {
            label: 'Postal Code',
          },
        },
      ],
    },
  ];
}